import { Text } from 'pixi.js';
import type { Container } from 'pixi.js';
import { onLayoutPopulated } from '../populate';
import type { VariableBank } from '../../../app/utils/VariableBank';
import { VariableBankUtils } from '../../../app/utils/VariableBankUtils';

export function variableSPL(variableBank: VariableBank): void {
  onLayoutPopulated.connect(
    (layout: {
      root: Container;
      // eslint-disable-next-line @typescript-eslint/naming-convention
      variable_SPL?: (Text | Container)[];
    }) => {
      if (!layout.variable_SPL) return;

      layout.variable_SPL.forEach((textObject) => {
        if (!(textObject instanceof Text)) return;

        VariableBankUtils.applyVariablesToText(variableBank, textObject);
      });
    },
  );
}
